import { collection, getDocs } from "firebase/firestore";
import { db } from "../../../backend/firebaseConfig";
import { getDepartmentConfig } from "../../Departments/utils/departmentConfig";

export const loadStaffDepartmentAccess = async () => {
  try {
    const ref = collection(db, "Authorized Members", "Staff", "Data");
    const snapshot = await getDocs(ref);

    const staff = snapshot.docs.map((docSnap) => {
      const data = docSnap.data() || {};
      const permissions = data.permissions || [];

      const config = getDepartmentConfig(permissions);

      const access = Object.values(config)
        .filter((dept) => dept.show)
        .map((dept) => ({
          department: dept.title,
          subDepartments: (dept.cards || []).map((c) => c.label),
        }));

      return {
        id: docSnap.id,
        email: data.email || docSnap.id,
        hasEmail: Boolean(String(data.email || "").trim()),
        employmentEndDate:
          data.employmentEndDate ||
          data.endDate ||
          data.leavingDate ||
          data.employment?.endDate ||
          null,
        permissions,
        access,
      };
    });

    return { success: true, data: staff };
  } catch (err) {
    console.error(err);
    return { success: false, data: [] };
  }
};
